import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  inject,
} from '@angular/core';

import { WarehouseReceiptFormComponent } from '../../components/warehouse-receipt-form/warehouse-receipt-form.component';
import { WarehouseReceiptFormData } from '../../models/warehouse-receipt-form-data';
import { WarehouseReceiptDataSourceService } from '../../services/warehouse-receipt-data-source.service';
import { once } from '@web/utils';
import { HttpErrorService } from '@web/common';
import { AlertsComponent, AlertsService } from '@web/shared/ui';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-warehouse-receipt-create',
  imports: [WarehouseReceiptFormComponent, AlertsComponent],
  templateUrl: './warehouse-receipt-create.component.html',
  styleUrl: './warehouse-receipt-create.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class WarehouseReceiptCreateComponent {
  /* prettier-ignore */
  private readonly warehouseReceiptDataSource = inject(WarehouseReceiptDataSourceService);
  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);

  public readonly fileUploadVisibility = input(false);
  public readonly submitSuccessEvent = output();

  public handleSubmitSuccessEvent(data: WarehouseReceiptFormData): void {
    this.warehouseReceiptDataSource
      .createByFormData(data)
      .pipe(once())
      .subscribe({
        next: () => {
          this.notifySubmitSuccessEvent();
        },
        error: (response) => this.showFailureAlertByResponse(response),
      });
  }

  private notifySubmitSuccessEvent(): void {
    this.submitSuccessEvent.emit();
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    this.alerts.showMultiple((builder) =>
      this.httpError
        .extract(response)
        .messages()
        .map((message) => builder.buildFailure(message)),
    );
  }
}
